import React from 'react';
import { useLazyQuery } from '@apollo/client';
import {
  IRolesQuery,
  IRolesQueryVariables,
} from '../../../../../utils/apollo/graphqlSchema';
import { GET_ROLES } from '../../../../../utils/apollo/permission';
import InlineMultiSelectMenu from '../../../../../components/Builder/InlineMultiSelectMenu';
import UsersFilterLabel from './UsersFilterLabel';
import * as BuilderUI from '../../../../../components/Builder/BuilderUI';

interface IProps {
  roles: string[];
  setRoles: (roles: string[]) => void;
}

const UserRoleFilter = ({ roles, setRoles }: IProps) => {
  const [loadRoles, { data, called }] = useLazyQuery<
    IRolesQuery,
    IRolesQueryVariables
  >(GET_ROLES, {
    variables: {
      term: '',
      includeDisabled: false,
      includes: [],
      pagination: { first: 0, after: 0 },
    },
  });

  const handleOpen = () => {
    if (!called) {
      loadRoles();
    }
  };

  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>Role</BuilderUI.BuilderFieldLabel>
      <InlineMultiSelectMenu
        label={<UsersFilterLabel selectedValues={roles} />}
        labelIsAlwaysActive={true}
        onMenuOpened={handleOpen}
        options={(data?.roles?.entities ?? []).map((role) => ({
          label: role.name,
          value: role.name,
          tooltipOption: {
            content: role.description,
          },
        }))}
        selectedKeys={roles}
        onSubmit={setRoles}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default UserRoleFilter;
